<script setup lang="ts">
// components
import AppButton from '@/components/App/AppButton.vue'
import IconChevronDown from '@/components/Icons/IconChevronDown.vue'

const emit = defineEmits(['toggleAdditives'])
defineProps({
  showAllAdditives: {
    type: Boolean,
    required: true,
  },
})
const toggleAdditives = () => emit('toggleAdditives')
</script>

<template>
  <div class="button-wrapper">
    <app-button
      class="button-wrapper__button"
      variant="text"
      @click="toggleAdditives"
    >
      <span v-if="showAllAdditives">Скрыть</span>
      <span v-else>Показать все</span>

      <div
        class="button-wrapper__button-icon"
        :class="{ 'button-wrapper__button-icon--rotate': showAllAdditives }"
      >
        <icon-chevron-down />
      </div>
    </app-button>
  </div>
</template>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-start;

  &__button {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: $primary;
    background-color: $white;
    box-shadow: none;

    &-icon {
      transition: all 0.15s ease-in-out;
      &--rotate {
        transform: rotate(-180deg);
      }
    }
  }
}

:deep(.v-btn__overlay),
:deep(.v-btn__underlay) {
  display: none;
}
</style>
